
import { getDefinitionByName } from "@goodgamestudios/createjs-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { Poker2Model } from "../../../../model/Poker2Model";
import { FeedbackBoxTeaser } from "../FeedbackBoxTeaser";
import { HalloweenTeaser } from "../HalloweenTeaser";
import { NeueFeaturesTeaser } from "../NeueFeaturesTeaser";
import { RabbitCamTeaser } from "../RabbitCamTeaser";
import { RebuyTeaser } from "../RebuyTeaser";
import { SlotmachineTeaser } from "../SlotmachineTeaser";
import { Tables50BBTeaser } from "../Tables50BBTeaser";
import { XmasTeaser } from "../XmasTeaser";
import { TeaserTextsVO } from "./TeaserTextsVO";
import { TeaserVO } from "./TeaserVO";

import MovieClip = createjs.MovieClip;

const logger = getLogger("TeaserFeatureFactory");

/**
 * TeaserFeatureFactory delivers the correct abstract teaser class for the desired feature teaser.
 * If an upcoming teaser needs special behaviour (e.g. additional buttons, logic et.) it is possible to put that logic into
 * the specific teaser classes.
 *
 * Workflow to add a new teaser:
 * 1. Copy an existing teaser movieclip in the PokerInterface.fla and design your new teaser like needed
 * 2. Add the library linkage name of your teaser mc into the compileTeaserFeatureMovieClipTemplates (to compile the assets into the final app)
 * 3. Write your custom teaser class which have to extend the AbstractTeaser
 * 4. Extend the switch/case condition in "compileTeaserFeatureMovieClipTemplates()" with the featureId and your custom teaser
 *
 * @author Patrick
 */
export class TeaserFeatureFactory {
    // The teaser templates have to be added into this array to compiled the assets into the final application SWF
    //public static compileTeaserFeatureMovieClipTemplates: any[] = [Library.PokerInterface.FeatureDialog_1, Library.PokerInterface.FeatureDialog_2, Library.PokerInterface.FeatureDialog_3, Library.PokerInterface.FeatureDialog_4, Library.PokerInterface.FeatureDialog_5, Library.PokerInterface.FeatureDialog_6, Library.PokerInterface.FeatureDialog_7, Library.PokerInterface.FeatureDialog_8];

    public static getTeaserFeatureById(featureId: number): TeaserVO {
        var teaserVO: TeaserVO = new TeaserVO();
        var teaserTexts: TeaserTextsVO = new TeaserTextsVO();

        // get default texts
        var title: string = Poker2Model.languageData.getTextById("feature_" + featureId + "_title");
        title = (title.length > 0) ? title : Poker2Model.languageData.getTextById("feature_title");
        var btnShopLabel: string = Poker2Model.languageData.getTextById("generic_payment_btn");
        var btnOkLabel: string = Poker2Model.languageData.getTextById("generic_btn_okay");

        // fill texts vo with the texts
        teaserTexts.titleStr = title;
        teaserTexts.btnShopLabel = btnShopLabel;
        teaserTexts.btnOkLabel = btnOkLabel;

        switch (featureId) {
            case 1:

                // NeueFeatures Teaser
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new NeueFeaturesTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 2:

                // Halloween Teaser 2011
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new HalloweenTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 3:

                // Slotmachine Teaser 2011
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new SlotmachineTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 4:

                // 50BB Teaser
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new Tables50BBTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 5:

                // XMAS Teaser
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new XmasTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 6:

                // FeedbackBox Teaser
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new FeedbackBoxTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 7:

                // RabbitCam Teaser
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new RabbitCamTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            case 8:

                // Rebuy Teaser
                // texts
                teaserVO.teaserTextsVO = teaserTexts;
                // teaser instance
                teaserVO.teaserInstance = new RebuyTeaser(featureId, TeaserFeatureFactory.getMovieClipAssetForTeaser(featureId), teaserVO);
                break;

            default:
                logger.error("compileTeaserFeatureMovieClipTemplates(), unknown featureId: " + featureId);
                break;
        }

        return teaserVO;
    }

    private static getMovieClipAssetForTeaser(featureId: number): MovieClip {
        var mcClass: any = getDefinitionByName("FeatureDialog_" + featureId) as any;
        return new mcClass() as MovieClip;
    }
}
